import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import css from './BackLink.module.css'

/*
 * When href is given, return an anchor tag.
 * When to is given, return a Link tag.
 */
export const BackLink = ({ children, href, to, ...rest }) => {
  const Component = href ? 'a' : Link
  const props = href
    ? {
        className: css.a,
        href: href
      }
    : {
        className: css.link,
        to: to || '/'
      }

  return (
    <Component {...props} {...rest}>
      <FontAwesomeIcon icon="angle-left" />
      <span className={css.text}>
        {children || 'Back to Hotline Operations'}
      </span>
    </Component>
  )
}
